import React from 'react'
import moment from 'moment'
import masks from 'lib/Masks'
import { toBrl } from 'lib/FloatFormat'

import BoletoService from 'services/boleto'
import { useQuery } from 'react-query'

import {
  Col,
  Divider,
  Drawer,
  Row,
  Spin
} from 'antd'

async function getDetail(_, idintegracao) {
  const { data } = await BoletoService.getBoleto(idintegracao)

  return data
}

const pStyle = {
  fontSize: 16,
  color: 'rgba(0,0,0,0.85)',
  lineHeight: '24px',
  display: 'block',
  marginBottom: 16
}

const DescriptionItem = ({ title, content }) => (
  <div
    style={{
      fontSize: 14,
      lineHeight: '22px',
      marginBottom: 7,
      color: 'rgba(0,0,0,0.65)'
    }}
  >
    <p
      style={{
        marginRight: 8,
        display: 'inline-block',
        color: 'rgba(0,0,0,0.85)'
      }}
    >
      {title}:
    </p>
    {content}
  </div>
)

const getMaskedCpfCnpj = (value) => {
  if (!value) {
    return ''
  }
  if (value.length === 11) {
    return masks['cpf'].apply(value)
  }
  if (value.length === 14) {
    return masks['cnpj'].apply(value)
  }
  return value
}

const getMaskedPhone = (value) => {
  if (!value) {
    return ''
  }

  return masks['phone'].apply(value)
}

function BoletoDetailData({ chargeData }) {
  return (
    <div>
      <p style={{ ...pStyle, marginBottom: 24 }}>Detalhes</p>
      <Divider orientation="left">Cobrança</Divider>
      <Row>
        <Col span={12}>
          <DescriptionItem title="Nosso Número" content={chargeData.TituloNossoNumero} />
        </Col>
        <Col span={12}>
          <DescriptionItem title="Número Documento" content={chargeData.TituloNumeroDocumento} />
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <DescriptionItem title="Valor" content={toBrl(chargeData.TituloValor)} />
        </Col>
        <Col span={12}>
          <DescriptionItem title="Vencimento" content={moment(chargeData.TituloDataVencimento).format('DD/MM/YYYY')} />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <DescriptionItem
            title="Linha digitável"
            content={chargeData.TituloLinhaDigitavel}
          />
        </Col>
      </Row>
      {((chargeData.TituloMensagem01) || (chargeData.TituloMensagem05)) && (
        <Row>
          <Col span={12}>
            <DescriptionItem title="Mensagens" />
          </Col>
          <Col span={12}>
            <Row>{chargeData.TituloMensagem01}</Row>
            <Row>{chargeData.TituloMensagem02}</Row>
            <Row>{chargeData.TituloMensagem03}</Row>
            <Row>{chargeData.TituloMensagem04}</Row>
            <Row>{chargeData.TituloMensagem05}</Row>
            <Row>{chargeData.TituloMensagem06}</Row>
            <Row>{chargeData.TituloMensagem07}</Row>
            <Row>{chargeData.TituloMensagem08}</Row>
            <Row>{chargeData.TituloMensagem09}</Row>
          </Col>
        </Row>
      )}
      {chargeData.situacao === 'LIQUIDADO' && (
        <Row>
          <Divider orientation="left">Pagamento</Divider>
          <Col span={12}>
            <DescriptionItem title="Valor Cobrado" content={toBrl(chargeData.TituloValor)} />
          </Col>
          <Col span={12}>
            <DescriptionItem title="Valor pago" content={toBrl(chargeData.PagamentoValorPago)} />
          </Col>
          <Col span={12}>
            <DescriptionItem title="Acréscimo" content={toBrl(chargeData.PagamentoValorAcrescimos)} />
          </Col>
          <Col span={12}>
            <DescriptionItem title="Desconto" content={toBrl(chargeData.PagamentoValorDesconto)} />
          </Col>
          <Col span={12}>
            <DescriptionItem title="Pagamento" content={moment(chargeData.PagamentoData).format('DD/MM/YYYY')} />
          </Col>
        </Row>
      )}
      <Divider orientation="left">Cedente</Divider>
      <Row>
        <Col span={12}>
          <DescriptionItem title="Nome" content={chargeData.razaosocial} />
        </Col>
        <Col span={12}>
          <DescriptionItem title="CPF / CNPJ" content={getMaskedCpfCnpj(chargeData.cpf_cnpj)} />
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <DescriptionItem title="E-mail" content={chargeData.email} />
        </Col>
        <Col span={12}>
          <DescriptionItem title="Telefone" content={getMaskedPhone(chargeData.telefone)} />
        </Col>
      </Row>
    </div>
  )
}

function BoletoDetailComponent(props) {
  const { executeOnClose, idintegracao } = props
  const { status, data } = useQuery(["detail", idintegracao], getDetail);

  return (
    <Drawer
    width={window.innerWidth > 600 ? 640 : window.innerWidth - 100}
      placement="right"
      closable
      destroyOnClose
      onClose={executeOnClose}
      visible={true}
    >
      <Spin tip="Carregando..." spinning={status === 'loading'} style={{ marginTop: 30 }}>
        { status === 'loading' ? <div></div> : <BoletoDetailData chargeData={data} /> }
      </Spin>
    </Drawer>
  )
}

export default BoletoDetailComponent

